export default __webpack_public_path__ + "static/media/turn-off-my-device.86105395.png";